import React, { FC, HTMLAttributes } from 'react';
import styles from './NoResults.module.scss';
import classNames from 'classnames';

export interface INoResults extends HTMLAttributes<HTMLDivElement> {
  children: any;
}

const NoResults: FC<INoResults> = (props) => {
  const { children } = props;
  const rootClassName = classNames(styles.noResults);

  return (
    <div className={rootClassName}>
      <div className={styles.noResultsMessage}>{children}</div>
    </div>
  );
};

export default NoResults;
